import React from 'react';
import { Badge } from 'components';

type Props = {
  value: string;
};

type Variant = 'success' | 'danger' | 'warning';

const attendanceStatuses = {
  PENDING: 'warning',
  SENT: 'warning',
  CONFIRMED: 'success',
  DECLINED: 'danger',
  FAILED: 'warning',
  EXPIRED: 'warning'
};

const ConfirmationStatus = ({ value }: Props) => {
  return value ? <Badge variant={(attendanceStatuses as any)[value] as Variant} value={value} /> : <span />;
};

export default ConfirmationStatus;
